import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type SessionsResponse} from './sessions-query-data';

export function sessionsTypePatcher(data: SessionsResponse): RestTypeWithTypename<SessionsResponse> {
    return {
        __typename: 'SessionsData',
        result: {
            __typename: 'Result',
            sessions: data.result.sessions.map(session => ({
                __typename: 'Session',
                ...session,
            })),
        },
    };
}
